import React, { useState } from "react";
import PropTypes from "prop-types";
import privateAxios from "../../utils/axiosPrivate";
import { showToast } from "../../utils/utils";
import { ThankYouModal } from "./ThankYouModal";
import {
  fundedInvoicesData,
  processing,
  modalActionBtn,
  commonPlaceHolderText
} from "../../locales/en";
import Style from "./modal.module.scss";
import { getCreditLimitRequestURL } from "../../utils/constants/apiEndPoints";
import CommonModal from "./CommonModal";
import { showToastType } from "../../utils/constants/appConstants";

const RequestCreditLimitModal = ({ isOpen, toggle, onCancel }) => {
  const [thankyouModal, setThankyouModal] = useState(false);
  const initialLoading = {
    creditRequestBtn: false
  };
  const initialFormData = {
    AmountRequested: "",
    SupportingComments: ""
  };
  const initialErrors = {
    AmountRequested: "",
    SupportingComments: ""
  };
  const [loading, setLoading] = useState(initialLoading);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState(initialErrors);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: ""
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.AmountRequested || formData.AmountRequested <= 0) {
      newErrors.AmountRequested = `${fundedInvoicesData?.RequestCreditLimitModal?.amountRequest}`;
    }
    if (!formData.SupportingComments.trim()) {
      newErrors.SupportingComments = `${fundedInvoicesData?.RequestCreditLimitModal?.supportingComment}`;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      setLoading((prev) => ({ ...prev, creditRequestBtn: true }));
      const { AmountRequested, SupportingComments } = formData;
      await privateAxios.post(
        `${getCreditLimitRequestURL}?requestedLimit=${AmountRequested}&userComment=${encodeURIComponent(SupportingComments)}`
      );
      setThankyouModal(true);
      setFormData({ AmountRequested: "", SupportingComments: "" });
      setErrors({ AmountRequested: "", SupportingComments: "" });
      toggle();
    } catch (error) {
      showToast(error?.response?.data?.message, showToastType.error);
    } finally {
      setLoading((prev) => ({ ...prev, creditRequestBtn: false }));
    }
  };

  const handleThankyouModal = () => {
    setThankyouModal(!thankyouModal);
  };

  const resetForm = () => {
    setFormData({ AmountRequested: "", SupportingComments: "" });
    setErrors({ AmountRequested: "", SupportingComments: "" });
  };

  const handleToggle = () => {
    resetForm();
    toggle();
    onCancel();
  };

  return (
    <>
      <CommonModal
        isOpen={isOpen}
        toggle={handleToggle}
        title={fundedInvoicesData?.RequestCreditLimitModal?.title}
        modalClassName={`${Style.xeroModal} modal-dialog-centered modal-md`}
        headerClassName={Style.creditModalHeader}
        bodyClassName={`${Style.manualUploadContent} modal-content border-0`}
      >
        <div className="request_credit d-flex flex-column">
          <br />
          <form onSubmit={handleFormSubmit} className="single-inv">
            <div className={Style.formGroup}>
              <label>
                {fundedInvoicesData?.RequestCreditLimitModal?.requstedAmount}
              </label>
              <input
                type="number"
                placeholder={commonPlaceHolderText?.placeholder_1}
                name="AmountRequested"
                className="number-arrows-hidden"
                value={formData.AmountRequested}
                onChange={handleChange}
                min={0}
              />
              {errors.AmountRequested && (
                <div className="text-danger small">
                  {errors.AmountRequested}
                </div>
              )}
            </div>
            <div className={Style.formGroup}>
              <label>
                {fundedInvoicesData?.RequestCreditLimitModal?.supportingCommnet}
              </label>
              <textarea
                placeholder={
                  fundedInvoicesData?.RequestCreditLimitModal
                    ?.supportingPlaceholder
                }
                name="SupportingComments"
                value={formData.SupportingComments}
                onChange={handleChange}
              />
              {errors.SupportingComments && (
                <div className="text-danger small">
                  {errors.SupportingComments}
                </div>
              )}
            </div>
            <div className={Style.formGroup}>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading.creditRequestBtn}
              >
                {loading.creditRequestBtn
                  ? processing
                  : `${modalActionBtn?.apply}`}
              </button>
            </div>
          </form>
        </div>
      </CommonModal>
      <ThankYouModal
        isOpen={thankyouModal}
        toggle={handleThankyouModal}
        btnContent={
          fundedInvoicesData?.RequestCreditLimitModal?.thankYouContent
        }
      />
    </>
  );
};

RequestCreditLimitModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onCancel: PropTypes.func
};

RequestCreditLimitModal.defaultProps = {
  onCancel: () => {}
};

export default RequestCreditLimitModal;
